import { createThemedStyles } from '@repo/theme/styles';
import { spacings } from 'component/constants';
import { LoadingSpinner } from 'component/progress/loading-spinner';
import React, { useRef, useState } from 'react';
import { type LayoutChangeEvent, View } from 'react-native';
import { t } from 'util/stdtypes';

export function ModerationInfoBannerLoader({ children, loading }: { children: React.ReactNode; loading?: boolean }) {
    const [childrenSize, setChildrenSize] = useState<{ width: number; height: number } | undefined>(undefined);
    const measuredRef = useRef(false);

    const onChildrenLayout = (e: LayoutChangeEvent) => {
        if (!measuredRef.current) {
            measuredRef.current = true;
            setChildrenSize({ width: e.nativeEvent.layout.width, height: e.nativeEvent.layout.height });
        }
    };

    return <View>{loading ? <BannerLoadingSpinner size={childrenSize} /> : <View onLayout={onChildrenLayout}>{children}</View>}</View>;
}

function BannerLoadingSpinner({ size }: { size?: { width: number; height: number } }) {
    const s = useModerationInfoBannerLoaderStyle();
    return (
        <View style={[s.container, size != null && { minHeight: size.height, minWidth: size.width }]}>
            <LoadingSpinner label={t('moderation.infoBannerLoader.label', 'Reviewing your response...')} />
        </View>
    );
}

const useModerationInfoBannerLoaderStyle = createThemedStyles((tokens) => ({
    container: {
        borderRadius: 8,
        backgroundColor: tokens.colors.colorSurfaceSecondary,
        padding: spacings.md,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: spacings.md,
        alignSelf: 'stretch',
    },
}));
